class DataService {
    static $inject = ["$http", "$q"];

    constructor($http, $q) {
        this.$http = $http;
        this.$q = $q;
        this.baseApiUrl = "api/v1/";
    }

    login = (username, password) => {
        return this.$http.post(`${this.baseApiUrl}security/login`, { username, password }).then(result => result.data);
    };

    logout = () => {
        return this.$http.post(`${this.baseApiUrl}security/logout`).then(result => result.data);
    };

    getSession = () => {
        return this.$http.get(`${this.baseApiUrl}sessions`).then(result => result.data);
    };


    getUserForCreatePassword = key => {
        return this.$http.get(`${this.baseApiUrl}users/for-create-password/${key}`).then(result => result.data);
    };

    updateUserPasswordFromKey = (key, password) => {
        return this.$http.post(`${this.baseApiUrl}security/update-password-from-key`, ({ key, password })).then(result => result.data);
    };

    resetPasswordRequest = request => {
        return this.$http.post(`${this.baseApiUrl}users/reset-password-request`, request).then(result => result.data);
    };

    createUserEmailRequest = request => {
        return this.$http.post(`${this.baseApiUrl}users/create-user-email-request`, request).then(result => result.data);
    };


    getCustomers = () => {
        return this.$http.get(`${this.baseApiUrl}customers`).then(result => result.data);
    };

    getCustomer = PIMS_customer_id => {
        return this.$http.get(`${this.baseApiUrl}customers/${PIMS_customer_id}`).then(result => result.data);
    };


    searchUsers = (page_size, page_number, order_by, order_descending, user_id, email, emp_id, is_npc_admin, is_manager, PIMS_customer_id, manager_id, include_disabled) => {
        return this.$http.post(`${this.baseApiUrl}users/search`,
            ({ page_size, page_number, order_by, order_descending, user_id, email, emp_id, is_npc_admin, is_manager, PIMS_customer_id, manager_id, include_disabled }))
            .then(result => result.data);
    };

    insertUser = request => {
        return this.$http.post(`${this.baseApiUrl}users`, request).then(result => result.data);
    };

    updateUser = request => {
        return this.$http.put(`${this.baseApiUrl}users/${request.user_id}`, request).then(result => result.data);
    };

    getUser = user_id => {
        return this.$http.get(`${this.baseApiUrl}users/${user_id}`).then(result => result.data);
    };

    getStatesAndCitiesForZipcode = zip_code => {
        return this.$http.get(`${this.baseApiUrl}users/states-cities-for-zipode/${zip_code}`).then(result => result.data);
    };

    userToggleRole = (user_id, prop_name, value) => {
        return this.$http.post(`${this.baseApiUrl}users/toggle-role`, ({ user_id, prop_name, value })).then(result => result.data);
    };

    getItems = PIMS_customer_id => {
        return this.$http.post(`${this.baseApiUrl}items/search`, ({ PIMS_customer_id })).then(result => result.data);
    };

    updateMultipleItems = request => {
        return this.$http.put(`${this.baseApiUrl}items/update-multiple`, request).then(result => result.data);
    };



    getOrdersUser = (page_size, page_number, order_by, order_descending, user_id) => {
        return this.$http.post(`${this.baseApiUrl}orders/search`,
            ({ page_size, page_number, order_by, order_descending, user_id }))
            .then(result => result.data);
    };

    getOrdersPending = (page_size, page_number, order_by, order_descending, manager_id) => {
        return this.$http.post(`${this.baseApiUrl}orders/search`,
            ({ page_size, page_number, order_by, order_descending, manager_id }))
            .then(result => result.data);
    };

    createOrder = request => {
        return this.$http.post(`${this.baseApiUrl}orders`, request).then(result => result.data);
    };

    getOrder = order_id => {
        return this.$http.get(`${this.baseApiUrl}orders/${order_id}`).then(result => {
            const order = result.data.order;
            order.lines = result.data.lines;
            order.shipments = result.data.shipments;
            order.shipments.forEach(s => {
                s.lines = result.data.shipment_lines.filter(sl => sl.PIMS_order_id === s.PIMS_order_id);
                s.details = result.data.shipment_details.filter(sd => sd.PIMS_order_id === s.PIMS_order_id);
            });
            return order;
        });
    };

    deleteOrder = order_id => {
        return this.$http.delete(`${this.baseApiUrl}orders/${order_id}`).then(result => result.data);
    };

    approveOrder = order_id => {
        return this.$http.post(`${this.baseApiUrl}orders/${order_id}/approve`).then(result => result.data);
    };

    rejectOrder = order_id => {
        return this.$http.post(`${this.baseApiUrl}orders/${order_id}/reject`).then(result => result.data);
    };

    publicApproveOrder = (order_id, user_id) => {
        return this.$http.post(`${this.baseApiUrl}orders/${order_id}/public-approve/${user_id}`).then(result => result.data);
    };

    publicRejectOrder = (order_id, user_id) => {
        return this.$http.post(`${this.baseApiUrl}orders/${order_id}/public-reject/${user_id}`).then(result => result.data);
    };

    createReturn = request => {
        return this.$http.post(`${this.baseApiUrl}returns`, request).then(result => result.data);
    };

    getReturns = (order_id, user_id) => {
        return this.$http.post(`${this.baseApiUrl}returns/search`, ({ order_id, user_id })).then(result => {
            result.data.orders.forEach(o => o.lines = result.data.lines.filter(l => l.return_id === o.return_id));
            return result.data;
        });
    };

    getShippingLabel = return_id => {
        return this.$http.get(`/api/v1/reports/shipping-label64/${return_id}`).then(result => result.data);
    };

    getPublicOrderLink = link_id => {
        return this.$http.get(`${this.baseApiUrl}public-order-links/${link_id}`).then(result => result.data);
    };

    _paginate = (array, pageSize, pageNumber) => {
        return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
    };
}

angular
    .module("app")
    .service("dataService", DataService);
